import { TagERP } from "@finanedi.es/storybook"

export const RazonSocialBodyTemplate = ({ razonSocial }: $TSMigrationFixMe) => {
  return <span>{razonSocial}</span>
}

export const NifBodyTemplate = ({ nif }: $TSMigrationFixMe) => {
  return <span>{nif}</span>
}

export const EtiquetasContactosBodyTemplate = ({
  etiquetas = [],
}: {
  etiquetas: string[] | null | undefined
}) => (
  <div className='tw-flex-wrap tw-gap-1 tw-flex tw-flex-row'>
    {etiquetas?.map((etiqueta, index) => {
      return (
        <TagERP
          key={`${index + 1}-etiqueta`}
          value={etiqueta}
          color='neutral'
          className='!tw-text-normal'
        />
      )
    })}
  </div>
)
